import { placementUrl } from "./AxiosInstance";

const getPlacementFileBaseUrl = () => {
  const configuredFileBaseUrl = process.env.REACT_APP_PLACEMENT_API_URL;
  const configuredApiUrl = placementUrl;
  const baseUrl = configuredFileBaseUrl || configuredApiUrl || window.location.origin;

  return baseUrl.replace(/\/api\/v1\/?$/, "").replace(/\/$/, "");
};

export const getResumeDownloadUrl = (cvUrl) => {
  if (!cvUrl) return "";

  if (/^https?:\/\//i.test(cvUrl)) {
    return cvUrl;
  }

  const resumePath = cvUrl.startsWith("/") ? cvUrl : `/${cvUrl}`;

  return `${getPlacementFileBaseUrl()}${resumePath}`;
};
